// extracted by mini-css-extract-plugin
module.exports = {"readMore":"cOZii","down":"_1-9Ow","up":"_2t-rw","border":"_2hOil","floatRight":"_3G6HK"};